import type { ReactNode } from 'react'

export const UserInfoPopoverSkeleton = (): ReactNode => (
  <div className="flex size-full flex-col items-start gap-10 p-[30px] sm:min-h-[250px] sm:w-[500px] sm:flex-row">
    <div className="size-40 min-h-[160px] min-w-[160px] rounded-full bg-skeleton-primary" />
    <div className="flex w-full grow flex-col gap-3">
      <div className="flex w-full flex-row gap-2">
        <div className="h-9 basis-1/2 rounded-xs bg-skeleton-primary" />
        <div className="h-9 basis-1/2 rounded-xs bg-skeleton-primary" />
      </div>
      <div className="h-5 rounded-xs bg-skeleton-primary" />
      <div className="h-5 rounded-xs bg-skeleton-primary" />
      <div className="h-5 rounded-xs bg-skeleton-primary" />
    </div>
  </div>
)
